import React from 'react';
// [reference]
//    플로팅이 기준을 삼을 레퍼런스의 위치
//    만약 null이면 마우스 위치가 레퍼런스 기준
// [placement]
//    screen-center
//                top-left    top     top-right
//    left-top                                    right-top
//    left                  reference             right
//    left-bottom                                 right-bottom
//                bottom-left bottom  bottom-right
// [connection]: 참조대상과 플로팅간에 연결선 종류.
//    start-arrow: 화살표가 참조대상을 가리킴
//    line: 화살표없이 선만 존재
//    end-arrow: 화살표가 플로팅을 가리킴
//    arrow: 화살표가 참조대상과 플로팅 양쪽을 가리킴
// [veilable]: 참조대상을 가릴 수 있는 여부 default=false
// [stickable]: 플로팅이 무조건 화면 안쪽에 위치 여부 default=true
// [selectable]: 사용자에 의해 선택 가능 (선택할 경우 z-index가 최상단으로 변경)
// [escapable]: Escape로 닫기 가능
// [movable]: 사용자에 의해 이동 가능
//      veilable이 true가 아닐 경우 사용 불가
//      stickable이 false가 아닐 경우 사용 불가
// [tags]: Floating을 보여주기 위해 필터링할때 사용하는 tag 목록
// [type]
//      'dialog'
//      'tooltips'
//      'popovers'
//      'dropdown'
//      'toast'
//      'snack'
// [buttons] {
//      label: string
//      autoFocus
//      ...props
// }
// [events] {
//      onEnter // 마우스 오버했을 때
//      onLeave // 마우스가 떠났을 때
//      onSelect // 선택했을 때
//      onMove // 움직였을 때
//      onClose // 닫힐때
//      onOuterClick // 플로팅 밖을 클릭
// }
export default function useFloating(props) {
  const {
    options: defaultOptions,
    setList,
    setHash,
  } = props || {};

  const update = React.useCallback((options) => {
    const {
      id,
    } = options;
    setHash(hash => !(id in hash) ? hash : ({ ...hash, [id]: { ...hash[id], ...options } }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const close = React.useCallback((id, callback) => {
    setHash(({ ...hash }) => {
      delete hash[id];
      return hash;
    });
    setList((list) => list.filter(item => item !== id));
    callback && callback();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const open = React.useCallback((options) => {
    const {
      id,
      //   reference, // Element
      //   placement,
      //   connection, // 'start-arrow' (default) | 'line' | 'end-arrow' | 'arrow' | 'none'
      //   width, // integer | 'auto'
      //   height, // integer | 'auto'
      //   veilable, // Boolean
      //   stickable, // Boolean
      //   movable, // Boolean
      //   closable, // Boolean
      //   escapable, // Boolean
      //   modal, // Boolean
      //   dim, // color (default='transparent')
      //   tags = [],
      //   type,
      //   title,
      //   description,
      //   contents,
      //   buttons = [],
      //   events = {},
    } = options;
    setList(list => [...list.filter(item => item !== id), id]);
    setHash(hash => ({ ...hash, [id]: { ...defaultOptions, ...options } }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    open,
    update,
    close,
  };
}
